import React from "react";
import PropTypes from "prop-types";
import { NotifyProvider } from "@Components/Notify";


const DefaultLayout = ({ children }) => (
  <NotifyProvider>
  <div
    style={{
      display: "flex",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {children}
  </div>
  </NotifyProvider>
);

DefaultLayout.propTypes = {
  children: PropTypes.element,
};

export default DefaultLayout;
